export default {"src":"/accounts/_next/static/media/my-footprint.48962e59.svg","height":972,"width":761,"blurWidth":0,"blurHeight":0};